// This function takes a count and a format string and returns a string
// that is formatted based on the count.
//
// The format string is a string that contains the following special
// characters:
//
// %s - if count is 1, replace with "", otherwise replace with "s"
// %c - replace with the count
// %[singular,plural] - if count is 1, replace with singular, otherwise
// replace with plural
//
// For example, the format string "%c%s" will return "1" if count is 1,
// and "2s" otherwise. The format string "%c %[apple,apples]" will return
// "1 apple" if count is 1, and "2 apples" otherwise.
export function pluralize(count: number, formatString: string) {
  const value = formatString
    .replace(/%s/g, count === 1 ? "" : "s")
    .replace(/%c/g, count.toString())
    .replace(/%\[(.*?)\]/g, (_, match) => {
      const [singular, plural] = match.split(",")
      return count === 1 ? singular : plural
    })

  if (process.env.NODE_ENV === "development") {
    const matches = value.match(/%(\w)/g)
    if (matches) {
      console.warn(
        `Unmatched pluralize format string: ${formatString}. Matches: ${matches.join(", ")}`,
      )
    }
  }

  return value
}

export function isUUID(str: string) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(str)
}

export function isUkPostcode(value: string) {
  return /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/i.test(value)
}

export function isEircode(value: string) {
  return /^(d6w|[a-z]\d\d)\s?[a-z0-9]{4}$/.test(value.toLowerCase().replace("o", "0"))
}

export function parameterize(str: string) {
  return str
    .replace(/[^a-zA-Z0-9]+/g, " ")
    .trim()
    .replace(/ /g, "-")
    .toLowerCase()
}
